module.exports = {"150402001":"西屯街道","150402002":"三中街街道","150402003":"永巨街道","150402004":"东城街道","150402005":"南新街街道","150402006":"站前街道","150402007":"铁南街道","150402008":"长青街道","150402009":"哈达街道","150402010":"西城街道","150402011":"桥北街道","150402100":"红庙子镇","150402102":"文钟镇","150402400":"红山高新技术产业园区管理委员会","150402401":"红山物流园区","150402402":"红山区农畜产品加工产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150402.json
// module id = 415
// module chunks = 0